export default __webpack_public_path__ + "static/media/camera.8a027809.svg";